import { useCallback } from 'react';
import { Sparkle } from 'lucide-react';
import clsx from 'clsx';
import { useVibeModeDockAvailability } from '@/modules/VibeMode/hooks/useVibeModeDockAvailability';
import { useVibeModeDockCommand } from '@/modules/VibeMode/hooks/useVibeModeDockCommand';
import { VibeModeDockIntent } from '@/modules/VibeMode/vibe-mode-dock.contract';
import type { VibeConsultationType } from '@/modules/VibeMode/vibe-mode-dock.contract';
import styles from '@/modules/VibeMode/components/VibeConsultationButton/VibeConsultationButton.module.css';

const LABEL = 'Ask Vibe Mode';

interface VibeConsultationButtonProps {
    consultationType: VibeConsultationType;
    attributeIdn: string;
    draftValue: string;
    isChanged: boolean;
}

const VibeConsultationButton = ({
    consultationType,
    attributeIdn,
    draftValue,
    isChanged
}: VibeConsultationButtonProps) => {
    const { isDockAvailable } = useVibeModeDockAvailability();
    const emitDockCommand = useVibeModeDockCommand();

    const handleClick = useCallback(() => {
        emitDockCommand({
            intent: VibeModeDockIntent.GetVibeConsultation,
            payload: {
                url: globalThis.location.href,
                updatedValue: isChanged ? draftValue : '',
                consultationType,
                attributeIdn
            }
        });
    }, [
        attributeIdn,
        consultationType,
        draftValue,
        emitDockCommand,
        isChanged
    ]);

    if (!isDockAvailable) {
        // eslint-disable-next-line unicorn/no-null
        return null;
    }

    return (
        <button
            className={clsx(styles.root, isChanged && styles.sheen)}
            data-testid="vibe-consultation-button"
            type="button"
            onClick={handleClick}
        >
            <Sparkle className={styles.icon} size={14} />
            {LABEL}
        </button>
    );
};

export default VibeConsultationButton;
